// Firebase configuration using environment variables
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
// Use environment variables when available, with graceful fallbacks for development
var firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'development-placeholder',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'development-placeholder',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'development-placeholder',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'development-placeholder',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '000000000000',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:000000000000:web:000000000000',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-0000000000'
};
// Initialize Firebase with error handling
var app;
// Initialize with empty objects that will be properly set in the try block
// or remain as safe fallbacks if initialization fails
var db = {};
var analytics = {};
try {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    // Only initialize analytics in production or when config is valid
    if (process.env.NODE_ENV === 'production' || firebaseConfig.measurementId !== 'G-0000000000') {
        analytics = getAnalytics(app);
    }
}
catch (error) {
    console.error('Firebase initialization error:', error);
    // We already initialized with empty objects above, so no need to set fallbacks here
}
export { db, analytics };
